import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

import { getLocales } from "@/lib/utils";

export const locales = getLocales();

export const routing = defineRouting({
    locales,

    defaultLocale: "fr",
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
